export default "__VITE_ASSET__dd56bfc3__"